module.exports = __webpack_public_path__ + "img/21_57.25cf07b1.png";